<template>
  <div class="comp-wrapper">
    <Item />
    <FooterBar />
  </div>
</template>

<script>
import Item from "./Item";
import FooterBar from "../../components/FloatingFooter/FooterBar";

export default {
  name: "ItemView",
  components: {
    Item,
    FooterBar,
  },
};
</script>